import type { StaffRole } from "@/lib/staff-api";

/** Mirror of the server's capabilities (src/api/src/lib/capabilities.ts).
 *  The server decides every request; this only picks what the client shows. */
export type StaffCapability = "manage_staff" | "work_queues" | "view_payments" | "view_directory";

const ROLE_CAPABILITIES: Record<StaffRole, readonly StaffCapability[]> = {
  it: ["manage_staff", "work_queues", "view_directory"],
  safe_environment: ["work_queues", "view_directory"],
  accounting: ["view_payments", "view_directory"],
};

export const STAFF_ROLE_LABELS: Record<StaffRole, string> = {
  it: "IT",
  safe_environment: "Safe Environment",
  accounting: "Accounting",
};

export function staffCan(role: StaffRole, capability: StaffCapability): boolean {
  return ROLE_CAPABILITIES[role].includes(capability);
}

/** Where a staff member lands after sign-in, and where a page they cannot use
 *  sends them. */
export function staffHomePath(role: StaffRole): string {
  return staffCan(role, "work_queues") ? "/staff" : "/staff/payments";
}
